import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

// User Profile
import UserProfile from "../pages/Authentication/user-profile";
import ImportFile from "../pages/ImportFile";
import InitialAnalysis from "../pages/Analysis";
import StockCheck from "../pages/StockCheck";
import FinalAnalysis from "../pages/FinalAnalysis";
import Products from "../pages/Products";
import Settings from "../pages/Settings";
import Orders from "../pages/Orders";
import Suppliers from "../pages/Suppliers";
import Users from "../pages/Users";
import CustomerOrders from "../pages/CustomerOrders";
import Dashboard from "../pages/Dashboard";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/products", component: <Products /> },
  { path: "/orders", component: <Orders /> },
  { path: "/customerOrders", component: <CustomerOrders /> },
  { path: "/import-file", component: <ImportFile /> },
  { path: "/stock-check", component: <StockCheck /> },
  { path: "/final-analysis", component: <FinalAnalysis /> },
  { path: "/initial-analysis", component: <InitialAnalysis /> },
  { path: "/settings", component: <Settings /> },
  { path: "/suppliers", component: <Suppliers /> },
  { path: "/users", component: <Users /> },

  //User Profile
  { path: "/profile", component: <UserProfile /> },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/products" />,
  },
  { path: "*", component: <Navigate to="/products" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes };
